(() => {
  const SELECTOR = '[data-stav-metal-swatch]';
  const CARD_SELECTOR = '.stav-product-card';

  const setImage = (card, button) => {
    const image = card.querySelector('.product__media .first-image');
    if (!image || !button.dataset.imageUrl) return;
    const mediaLink = card.querySelector('.product__media');
    mediaLink?.classList.remove('show_secondary');
    card.querySelectorAll('.product__media .secondary-image').forEach((secondary) => {
      secondary.hidden = true;
    });
    if (button.dataset.imageSrcset) image.srcset = button.dataset.imageSrcset;
    image.src = button.dataset.imageUrl;
    image.alt = button.dataset.imageAlt || image.alt;
  };

  const setPrice = (card, button) => {
    const price = card.querySelector('[data-stav-card-price]');
    const priceTemplate = button.querySelector('[data-stav-variant-price]');
    if (!price || !priceTemplate) return;
    price.replaceChildren(priceTemplate.content.cloneNode(true));
  };

  const selectSwatch = (button) => {
    const card = button.closest(CARD_SELECTOR);
    if (!card) return;
    card.querySelectorAll(SELECTOR).forEach((swatch) => {
      const selected = swatch === button;
      swatch.setAttribute('aria-pressed', String(selected));
      swatch.classList.toggle('is-selected', selected);
    });
    const facts = card.querySelector('[data-stav-card-material]');
    if (facts && button.dataset.material) facts.textContent = button.dataset.material;
    card.querySelectorAll('[data-stav-product-link]').forEach((link) => {
      link.href = button.dataset.variantUrl;
    });
    setImage(card, button);
    setPrice(card, button);
  };

  const initializeCards = (root = document) => {
    root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      if (card.dataset.stavMetalInitialized === 'true') return;
      const selected = card.querySelector(`${SELECTOR}[aria-pressed="true"]`);
      if (!selected) return;
      selectSwatch(selected);
      card.dataset.stavMetalInitialized = 'true';
    });
  };

  const preloadSwatch = (button) => {
    if (!button?.dataset.imageUrl || button.dataset.stavPreloaded === 'true') return;
    const preload = new Image();
    preload.src = button.dataset.imageUrl;
    button.dataset.stavPreloaded = 'true';
  };

  document.addEventListener('pointerover', (event) => {
    preloadSwatch(event.target.closest(SELECTOR));
  });

  document.addEventListener('focusin', (event) => {
    preloadSwatch(event.target.closest(SELECTOR));
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest(SELECTOR);
    if (!button) return;
    event.preventDefault();
    selectSwatch(button);
  });

  const initializeAddedCards = (nodes) => {
    nodes.forEach((node) => {
      if (!(node instanceof Element)) return;
      if (node.matches(CARD_SELECTOR) || node.querySelector(CARD_SELECTOR)) initializeCards(node);
    });
  };

  const observeGridUpdates = () => {
    const main = document.getElementById('MainContent');
    if (!main || main.dataset.stavMetalObserver === 'true') return;
    main.dataset.stavMetalObserver = 'true';
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => initializeAddedCards([...mutation.addedNodes]));
    }).observe(main, { childList: true, subtree: true });
  };

  ['DOMContentLoaded', 'shopify:section:load'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      initializeCards(event.target instanceof Element ? event.target : document);
      observeGridUpdates();
    });
  });

  initializeCards();
  observeGridUpdates();
})();
